import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "src/app/modules/auth/auth.service";
import { TokenStorageService } from "src/app/modules/auth/token-storage.service";
import { DataService } from "src/app/services/data.services";
import { AppConstants } from "src/app/app.constants";
const TOKEN_HEADER_KEY = "Authorization";

@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private token: TokenStorageService,
    private dataService: DataService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.token.getAuthToken();

    if (
      request.url.toString().toLocaleLowerCase().indexOf("signinwithcookie") >=
      0
    ) {
      request = request.clone({
        withCredentials: true,
      });
    } else if (token != null) {
      request = request.clone({
        headers: request.headers.set(TOKEN_HEADER_KEY, "Bearer " + token),
      });
    }

    request.headers.set("Access-Control-Allow-Origin", AppConstants.server_Url);

    // return next.handle(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error.message);// Adding this log to get error message, in case of authentication failure
        if (error.status === 401) {
          this.authService.logout();
          console.log("Error in login");
        }
        this.dataService.screenLoaderDataSubject.next({ show: false });
        return throwError(error);
      })
    );
  }
  private tokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
export const ApiResponseInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiResponseInterceptor, multi: true },
];
